// saga.ts
import { call, put, takeEvery } from 'redux-saga/effects';
import { createTally, deleteTally, getTallyApi, updateTally } from '../../api/TallyApi'; // Adjust the path as needed
import {
    getTallySuccess,
    getTallyFailure,
    createTallySuccess,
    createTallyFailure,
    updateTallySuccess,
    updateTallyFailure,
    deleteTallySuccess,
    deleteTallyFailure,
} from './actions';

// Saga to handle fetching Tallys
function* fetchTallySaga(action: any): Generator<any, any, any> {
    try {
        const data = yield call(getTallyApi, action.payload);
        yield put(getTallySuccess(data));
    } catch (error: any) {
        const errorMessage = error?.response?.data?.meta?.message
            ? error.response
            : error?.message
            ? error.message
            : 'An unexpected error occurred';

        yield put(getTallyFailure(errorMessage));
    }
}

// // Saga to handle creating a Tally
function* createTallySaga(action: any): Generator<any, any, any> {
    try {
        const data = yield call(createTally, action.payload);
        yield put(createTallySuccess(data));
    } catch (error: any) {
        const errorMessage = error?.response?.data?.meta?.message
            ? error.response
            : error?.message
            ? error.message
            : 'An unexpected error occurred';

        yield put(createTallyFailure(errorMessage));
    }
}

// // Saga to handle updating a Tally
function* updateTallySaga(action: any): Generator<any, any, any> {
    try {
        const data = yield call(updateTally, action.payload.data, action.payload.id);
        yield put(updateTallySuccess(data));
    } catch (error: any) {
        const errorMessage = error?.response?.data?.meta?.message
            ? error.response
            : error?.message
            ? error.message
            : 'An unexpected error occurred';

        yield put(updateTallyFailure(errorMessage));
    }
}

// // Saga to handle updating a Tally
function* deleteTallySaga(action: any): Generator<any, any, any> {
    try {
        const data = yield call(deleteTally, action.payload.id);
        yield put(deleteTallySuccess(data));
    } catch (error: any) {
        const errorMessage = error?.response?.data?.meta?.message
            ? error.response
            : error?.message
            ? error.message
            : 'An unexpected error occurred';
        yield put(deleteTallyFailure(errorMessage));
    }
}

export default function* tallySaga() {
    yield takeEvery('GET_TALLY_REQUEST', fetchTallySaga);
    yield takeEvery('CREATE_TALLY_REQUEST', createTallySaga);
    yield takeEvery('UPDATE_TALLY_REQUEST', updateTallySaga);
    yield takeEvery('DELETE_TALLY_REQUEST', deleteTallySaga);
}
